export enum PodSearchParams {
  selectedInvoices = "selected-invoices",
  allDuplicates = "all-duplicates",
}

export interface SearchParams {
  [PodSearchParams.selectedInvoices]: string;
  [PodSearchParams.allDuplicates]: string;
}
